export const SELECT_VEHICLE_TRANSIT_STATUS = 'V3SELECT_VEHICLE_TRANSIT_STATUS';
export const SELECT_EVENT_TYPE = `V3SELECT_EVENT_TYPE`